import CityPageTemplate from "../city-template/CityPageTemplate";
import { highPointConfig } from "./data";

export default function HighPointPage() {
  return <CityPageTemplate config={highPointConfig} />;
}